import { AreaChartProps } from '@mantine/charts'

export const GRID_COLOR = '#2d3748'
export const TICK_COLOR = '#a0aec0'
export const XAIXIS_LINE_COLOR = '#4a5568'
export const TICK_FONT_SIZE = 6
export const DEFAULT_YAXIS_TICK_WIDTH = 35
export const XAIXIS_TICK_DISPLAY_COUNT = 3

export const baseShareAreaChartYAxisProps: Required<AreaChartProps>['yAxisProps'] = {
  domain: ['dataMin * 0.9', 'dataMax * 1.1'],
  tickFormatter: value => value.toFixed(2),
  tick: {
    fill: TICK_COLOR,
    width: 100,
    strokeWidth: 0,
    fontSize: TICK_FONT_SIZE,
    transform: 'translate(4, 0)',
  },
  tickLine: {
    stroke: GRID_COLOR,
  },
}

export const baseShareAreaChartProps: Omit<AreaChartProps, 'data'> = {
  w: 148,
  h: 135,
  gridAxis: 'xy',
  dataKey: 'timestamp',
  withTooltip: false,
  withDots: false,
  strokeWidth: 1,
  strokeDasharray: 0,
  series: [
    {
      name: 'value',
      color: 'var(--border-status-active)',
    },
  ],
  areaProps: {
    isAnimationActive: false,
  },
  gridProps: {
    stroke: GRID_COLOR,
  },
}
